import React, { useState } from "react";
import {
  Stack,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "firebaseApp";
import { useSelector } from "react-redux";
import SimpleMarkdownEditor from "components/ai-editor/SimpleMarkdownEditor";
import { doc, updateDoc } from "firebase/firestore";
import SectionContainer from "components/ai-editor/SectionContainer";
import AttachFileButton from "components/attachments/v2/AttachFileButton";
import AttachmentList from "components/files/AttachmentList";
import ToggleEditPromptMenuItem from "components/ai-editor/ToggleEditPromptMenuItem";
import toast from "react-hot-toast";
import AITextEditMenuItem from "components/ai-editor/AITextEditMenuItem";

export const AI_TYPE = {
  key: "ai",
  default: {
    text: "",
    prompt: "",
  },
};

export default function AIBlock({ section, dragHandleProps }) {
  const botState = useSelector((state) => state.bot);

  const [promptingMode, setPromptingMode] = useState(!Boolean(section.text));
  const [prompt, setPrompt] = useState(section.prompt);
  const [text, setText] = useState(section.text);
  const [generating, setGenerating] = useState(false);

  const handleGenerate = async () => {
    try {
      setGenerating(true);
      const res = await httpsCallable(
        functions,
        "generateSectionText"
      )({
        botId: botState.current,
        prompt,
        documentId: section.documentId,
        sectionId: section.id,
      });
      const resData = res.data;
      if (resData.error) {
        toast.error(resData.error);
      } else {
        setText(resData.result);
        setPromptingMode(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGenerating(false);
    }
  };

  const save = () => {
    console.log(prompt, text);
    updateDoc(
      doc(db, "documents", section.documentId, "sections", section.id),
      {
        prompt,
        text,
      }
    );
  };

  const renderContent = () => {
    if (promptingMode) {
      return (
        <Stack spacing={1}>
          <TextField
            label="Prompt"
            value={prompt}
            onChange={(event) => setPrompt(event.target.value)}
            disabled={generating}
            multiline
          />
          <Button
            startIcon={
              generating ? <CircularProgress size={24} /> : <AutoAwesomeIcon />
            }
            onClick={handleGenerate}
            disabled={!Boolean(prompt) || generating}
          >
            Generate
          </Button>
        </Stack>
      );
    }
    return (
      <SimpleMarkdownEditor
        value={text}
        setValue={setText}
        onBlur={save}
        onTogglePreivew={save}
      />
    );
  };

  return (
    <SectionContainer
      section={section}
      dragHandleProps={dragHandleProps}
      menuItems={[
        <ToggleEditPromptMenuItem
          promptingMode={promptingMode}
          setPromptingMode={setPromptingMode}
        />,
        <AITextEditMenuItem text={text} setText={setText} />,
      ]}
    >
      <Stack direction="row" mb={1} alignItems="flex-start" pr={1}>
        <AttachFileButton
          targetId={section.id}
          modalTitle={"Attach data to AI section"}
          sx={{
            mt: 0.3,
          }}
        />
        <AttachmentList
          label="Section attachments"
          targetId={section?.id}
          sx={{
            flex: 1,
          }}
        />
      </Stack>
      {renderContent()}
    </SectionContainer>
  );
}
